import React from "react";
import ProgramStatusTable from "./ProgramStatusTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const ProgramStatusIndex = () => (
  <ReportProgramsPage
    TableComponent={ProgramStatusTable}
    loadingMessage="Loading program status..."
  />
);

export default ProgramStatusIndex;
